import React from "react";
import styled from "styled-components";

import PageWrapper from "../../Components/Common/PageWrapper";
import ErcHistory from "./ErcHistory";
import EthHistory from "./EthHistory";
import useState from "../../Hooks/useState";

const SelectBox = styled.div`
  width: 90%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const SelectItem = styled.div`
  width: 100%;
  height: 120px;
  border-radius: 10px;
  background-color: ${(props) => props.theme.mainColor};
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 25px;
  font-weight: bold;
  :hover {
    opacity: 0.75;
    cursor: pointer;
  }
  :first-child {
    margin-bottom: 15px;
  }
`;

const SelectForm = styled.div``;

const Container = () => {
  const phase = useState(null);

  const phaseOnClick = (type) => {
    phase.setState(type);
  };

  return (
    <PageWrapper contentStyle={{ justifyContent: "center" }}>
      {phase.state === null && (
        <SelectBox>
          <SelectItem onClick={phaseOnClick.bind(null, "eth")}>Ethereum</SelectItem>
          <SelectItem onClick={phaseOnClick.bind(null, "erc-20")}>ERC-20</SelectItem>
        </SelectBox>
      )}
      {phase.state === "eth" && <EthHistory phase={phase} />}
      {phase.state === "erc-20" && <ErcHistory phase={phase} />}
    </PageWrapper>
  );
};

export default Container;
